import { render, staticRenderFns } from "./BemiddelaarWelkom.vue?vue&type=template&id=51b2ff02&"
import script from "./BemiddelaarWelkom.vue?vue&type=script&lang=js&"
export * from "./BemiddelaarWelkom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports